export const MOBILE_STORES  = {
    "playStoreUrl": "https://play.google.com/store/apps/details?id=io.nuins.app",
    "appStoreUrl": "https://apps.apple.com/us/app/nu-ins/id1505693067",
    "appGalleryUrl": "https://appgallery.huawei.com/#/app/C103923615",
    "videoUrl": "https://www.youtube.com/embed/YGAwGk_5Q8Y"
}